import { useRetryMembershipChargePayment } from 'api/Memberships'
import { Notification, useNotificationContext } from 'ui/components/Notification'
import { formatMoney } from 'ui/components/Money'
import { DateTime } from 'luxon'
import { Text } from 'ui/components/Text'
import { ConfirmationModal } from 'ui/Modal'

export const RetryMembershipChargeModal = ({ isOpen, onClose, charge }) => {
  const { isLoading, mutate } = useRetryMembershipChargePayment()
  const notification = useNotificationContext()

  const handleRetry = () => {
    mutate([charge.id], {
      onSuccess: () => {
        onClose()
        notification.notify(
          <Notification
            title="Membership charge retried successfully"
            description={`The membership charge has been retried successfully.`}
            variant="success"
            autoDismiss
          />
        )
      },
      onError: (response) => {
        notification.notifyApiError(response)
        onClose()
      },
    })
  }

  return (
    <ConfirmationModal
      isOpen={isOpen}
      title="Retry membership charge"
      onClose={onClose}
      onConfirm={handleRetry}
      confirming={isLoading}
      confirmButtonLabel="Retry Charge"
      variant="info"
    >
      {charge !== null && (
        <>
          <Text type="caption">
            You are about to retry a charge for the period{' '}
            {DateTime.fromJSDate(charge?.billing_period_from).toLocaleString(DateTime.DATE_MED)} to{' '}
            {DateTime.fromJSDate(charge?.billing_period_to).toLocaleString(DateTime.DATE_MED)}
          </Text>
          <Text type="caption" className="mt-2">
            Are you sure you want to retry this membership charge of{' '}
            {formatMoney({ amount: charge?.amount, currency: charge?.currency })}?
          </Text>
        </>
      )}
    </ConfirmationModal>
  )
}
